import PropTypes from 'prop-types'
import { FormControl } from 'baseui/form-control'
import { SIZE } from 'baseui/button'
import { Card } from 'baseui/card'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import { Editor } from '@tinymce/tinymce-react'
import useCommunicationBoard from './useCommunicationBoard'

import {
  FieldsColumn,
  ActionsRow,
  BoardPageWrapper
} from './styled-components'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'

const CommunicationBoardTool = ({ urls }) => {
  const {
    t,
    tinymceKey,
    section,
    content,
    sectionsList,
    loading,
    saving,
    error,
    handleSave,
    handleSectionChange,
    handleContentChange,
    editorRef,
  } = useCommunicationBoard(urls)

  const sectionsOptions = sectionsList.reduce((acc, { id, label }) => { acc[id] = label; return acc }, {});

  return (
    <BoardPageWrapper>
      <Card
        overrides={{
          Root: {
            style: {
              width: '100%',
              maxWidth: '800px',
            },
          },
        }}
      >
      <h2 style={{ marginTop: 0, marginBottom: 14, fontWeight: 600, fontSize: '1.2rem', alignSelf: 'flex-start' }}>
        {t('communication:board_title', 'Communication Board Message')}
      </h2>
      <FieldsColumn>
        <FormControl>
          <SDSelect
            label={t('devTools:communication_board.section')}
            optionsList={sectionsOptions}
            selectedValue={section}
            onChangeHandler={params => handleSectionChange(params.option?.id)}
            placeholder={t('common:choose')}
          />
        </FormControl>
      </FieldsColumn>
      <FormControl label={t('devTools:communication_board.message')} error={error}>
          <Editor
            apiKey={tinymceKey}
            value={content}
            onInit={(_evt, editor) => { editorRef.current = editor }}
            onEditorChange={handleContentChange}
            init={{
              plugins: [
                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                'preview', 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                'insertdatetime', 'media', 'table', 'code', 'wordcount', 'emoticons'
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | removeformat | emoticons | help | code',
              height: 240,
              menubar: false,
            }}
          />
      </FormControl>
      <ActionsRow>
        <SDButton
          size={SIZE.compact}
          block={false}
          disabled={saving}
          onClick={handleSave}
        >
          {saving ? t('common:saving') : t('common:save')}
        </SDButton>
        <SDLoader hidden={!loading} text={t('common:fetching_data')} />
        <SDNotification type='negative' hidden={!error} primaryText={error} />
      </ActionsRow>
      </Card>
    </BoardPageWrapper>
  )
}

CommunicationBoardTool.propTypes = {
  urls: PropTypes.object.isRequired,
}
export default CommunicationBoardTool
